

import { Loader2 } from 'lucide-react';

interface EmailPreviewDisplayProps {
  emailType: 'summary' | 'insight';
  viewMode: 'preview' | 'source';
  isLoading: boolean;
  emailHtml: string;
}

export function EmailPreviewDisplay({
  emailType,
  viewMode,
  isLoading,
  emailHtml
}: EmailPreviewDisplayProps) {
  const renderLoadingState = () => (
    <div className="flex flex-col items-center justify-center p-8">
      <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
      <p className="text-muted-foreground">Loading email preview...</p>
    </div>
  );

  return (
    <div className="border rounded-md overflow-hidden">
      <div className="bg-muted px-4 py-2 border-b flex items-center justify-between">
        <div className="text-sm font-medium">
          {emailType === 'summary' ? 'Summary Email' : 'Insight Email'} Preview
        </div>
      </div>
      
      <div className="bg-white">
        {isLoading ? (
          renderLoadingState()
        ) : viewMode === 'preview' ? (
          <div 
            className="h-[600px] overflow-auto p-1"
            dangerouslySetInnerHTML={{ __html: emailHtml }} 
          />
        ) : (
          <pre className="h-[600px] overflow-auto p-4 text-xs bg-black text-white">
            {emailHtml}
          </pre>
        )}
      </div>
    </div>
  );
}
